import React from 'react';
import {
	Wrapper,
	DropdownWrapper,
	ButtonsWrapper,
	OptionInfo,
	OptionLabel,
	CompanyTitle,
} from './CompanyHeader.styles';
import {
	ApButtonIcon,
	ApSimpleDropdown,
	colors,
} from '@alixpartners/ui-components';
import { Link } from 'react-router-dom';
import { SortMenu } from '../SortMenu';
import { SearchMenu } from '../SearchMenu';
import useResizeObserver from 'use-resize-observer';

export const CompanyHeader = ({
	title,
	selectedItem,
	options,
	onChange,
	onSortChange,
	searchOptions,
	currencySymbol,
	onSearch,
	previewUrl,
}) => {
	const companyOptions = options
		? options.map(option => {
				return {
					...option,
					labelNode: (
						<OptionLabel>
							<CompanyTitle title={option.label}>{option.label}{' '}</CompanyTitle>
							<OptionInfo>{option.percentage}% mapped</OptionInfo>
						</OptionLabel>
					),
				};
		  })
		: [];
	const { ref, width = 0 } = useResizeObserver({
		box: 'border-box',
	});
	const hideCompanySelect = !!title;

	return (
		<Wrapper
			color={selectedItem && selectedItem.color}
			innerRef={ref}
			hideCompanySelect={hideCompanySelect}
		>
			{hideCompanySelect ? (
				<div>{title}</div>
			) : (
				<DropdownWrapper>
					<ApSimpleDropdown
						options={companyOptions}
						selected={selectedItem}
						onChange={onChange}
					/>
				</DropdownWrapper>
			)}
			<ButtonsWrapper>
				<Link to={previewUrl} target="_blank">
					<ApButtonIcon
						iconName="launch"
						iconProps={{ iconColor: colors.green1 }}
					/>
				</Link>
				<SearchMenu
					onSearch={onSearch}
					offsetRight={-92}
					width={width}
					options={searchOptions}
					currencySymbol={currencySymbol}
				/>
				<SortMenu onChange={onSortChange} />
			</ButtonsWrapper>
		</Wrapper>
	);
};

export default CompanyHeader;
